$(function(){

	$('.j-id').selectric('destroy');

	// Toggle item list adctiev class
	$(document).on('click', '.item-list a, .value-list a', function(e){
	
		e.preventDefault();
		$(this).addClass('active').siblings().removeClass('active');

	});

	//Filter master select function

	$(document).on('filter', '.j-id', function() {

		//console.log('EVENT FIRED');

		$(this).find('option').prop('disabled', true);

		// var skuFilter = $(this).data('variant-sku') ? '' + $(this).data('variant-sku') + '' : '';

		var sizeFilter = $(this).data('filtered-size') ? '[data-size=' + $(this).data('filtered-size') + ']' : '';
		var colourFilter = $(this).data('filtered-colour') ? '[data-colour=' + $(this).data('filtered-colour') + ']' : '';

		$(this).find('option' + colourFilter).prop('disabled', false);

		$(this).closest('form').find('.size-list a').addClass('disabled').find('.j-variant-price').text('n/a');

		$(this).find('option[data-sold-out]');

		$(this).find('option' + colourFilter + sizeFilter + ':enabled:first').prop('selected', true);

		$(this).find('option:enabled').each(function() {
			
			$(this).closest('form').find('.size-list a[data-size=' + $(this).data('size') + ']').removeClass('disabled').find('.j-variant-price').text($(this).data('price'));

		});

		$(this).closest('form').find('.size-list a[data-size='+$(this).find('option:selected').data('size') + ']').addClass('active').siblings().removeClass('active');

		// Get selected option cost per serving and update
		var cps = $(this).find('option:selected').data('cost-per-serving');
		//console.log('Cost per serving: ' + cps);
		$(this).closest('form').find('.j-update-cps').text(cps);

		// Get selected option price and update
		var vprice = $(this).find('option:selected').data('price');
		//console.log('Variant price: ' + vprice);
		$(this).closest('form').find('.j-update-compare-at-price').text(vprice);

		// Get selected option compare-at-price and update
		var vcompareprice = $(this).find('option:selected').data('compare-at-price');
		//console.log('Variant compare at price: ' + vcompareprice);
		$(this).closest('form').find('.j-update-price').text(vcompareprice);

		var vsize = $(this).find('option:selected').data('size-human');
		//console.log('Variant size: ' + vsize);
		$(this).closest('form').find('.j-change-size').text(vsize);

		var vcolour = $(this).find('option:selected').data('colour-human');
		$(this).closest('form').find('.j-change-colour').text(vcolour);

		var variant_value = $(this).find('option:selected').val();
		//console.log('Final value: ' + variant_value);
		$(this).closest('form').find('.add-to-cart-btn').val(variant_value);



		console.log($(this).find('option:selected').data('variant-img'));

		$('.j-giftcard-wrap .item').each(function(i){
			if ($(this).data('variant') == variant_value) {
				var slideIndex = $(this).closest('.slick-slide').data('slick-index');
				console.log(slideIndex);
				if ($('.j-giftcard-wrap').hasClass('slick-initialized')) {
					$('.j-giftcard-wrap').slick('slickGoTo', slideIndex);
				}
			}
		});

		console.log('oos', $(this).find('option:selected').attr('data-sold-out'));

		if ($(this).find('option:selected').attr('data-sold-out') == 'true') {
			$(this).closest('form').find('.add-to-basket').hide();
			$(this).closest('form').find('#oos_button').fadeIn();
			$(this).closest('form').find('.klaviyo-bis-trigger').fadeIn();
		} else {
			$(this).closest('form').find('.add-to-basket').fadeIn();
			$(this).closest('form').find('#oos_button').hide();
			$(this).closest('form').find('.klaviyo-bis-trigger').hide();
		}

		console.log(variant_value);
		
		$('input[name="id"]').val(variant_value);

	})

	// On variant change

	$(document).on('click', '.j-select-size, .j-select-colour', function(e) {
		e.preventDefault();

		if($(this).data('size')) {
			// filter by size
			$(this).closest('form').find('.j-id').data('filtered-size', $(this).data('size'));
		}

		if($(this).data('colour')) {
			// filter by colour
			$(this).closest('form').find('.j-id').data('filtered-colour', $(this).data('colour'));
			$(this).closest('form').find('.j-id').data('filtered-size', '');

		}

		if($(this).data('block')) {
			let block_value = $(this).data('block')

			$('.j-giftcard-wrap .item').each(function(i){
				if ($(this).data('block') == block_value) {
					var slideIndex = $(this).closest('.slick-slide').data('slick-index');
					if ($('.j-giftcard-wrap').hasClass('slick-initialized')) {
						$('.j-giftcard-wrap').slick('slickGoTo', slideIndex);
					}
				}
			});
		}

		$(this).closest('form').find('.j-id').trigger('filter');

	});

	// $('.j-select-size:first, .j-select-colour:first').trigger('click');
	$('.j-id').trigger('filter');

	// Update quantity

	$(document).on('click', '.product-template-wrapper .j-qty-change span', function(){
		console.log('click');
		if( $(this).hasClass('minus') ){

			if( $(this).parent().find('.j-quantity-update').val() < 2 ){
				console.log('smaller than 0');
				//$('.update_container').addClass('show');
			} else {

				var counter = parseInt($(this).parent().find('.j-quantity-update').val());
				counter--;
				$(this).parent().find('.j-quantity-update').attr('value', counter);

			}

		}

		if( $(this).hasClass('plus') ){

			var counter = parseInt($(this).parent().find('.j-quantity-update').val());
			counter++;
			$(this).parent().find('.j-quantity-update').attr('value', counter);

		}

		console.log(counter);
		console.log($(this).closest('form').find('.add-to-basket'));
		$(this).closest('form').find('.add-to-basket').data('quantity', counter);

	});

});